import type { CategoryEntity } from '~/core/services/ApiClient'
import { zoneHome } from '~/constants/DefaultValue'
import type { ZoneTreeDto } from '~/core/types/zone'

export function buildZoneTree(categories: CategoryEntity[] | undefined): ZoneTreeDto[] {
  if (!categories?.length) {
    return [zoneHome]
  }

  const nodes = new Map<number, ZoneTreeDto>()
  for (const category of categories) {
    if (!category.id) continue
    nodes.set(category.id, {
      id: category.id,
      label: category.name,
      name: category.name,
      children: [],
    })
  }

  const roots: ZoneTreeDto[] = []
  for (const category of categories) {
    if (!category.id) continue
    const node = nodes.get(category.id)!
    if (category.parentId && nodes.has(category.parentId)) {
      nodes.get(category.parentId)!.children!.push(node)
    } else {
      roots.push(node)
    }
  }

  return [zoneHome, ...roots]
}
